import {ReactElement, useEffect, useState} from "react";
import {useAuthenticationContext} from "./AuthenticationContext";
import {VivoPortal} from "../AppConstants";
import EnumMemberGroupAliases = VivoPortal.EnumMemberGroupAliases;
import {JwtUtils} from "./JwtUtils";
import getToken = JwtUtils.getToken;

export default function Authorized(props: authorizedProps) {
    const [isRoleAuthorized, setIsRoleAuthorized] = useState<boolean>(false);
    const [isLabAuthorized, setIsLabAuthorized] = useState<boolean>(true);
    const [isDivisionAuthorized, setIsDivisionAuthorized] = useState<boolean>(true);
    const {roleMask, rootModel} = useAuthenticationContext();
    useEffect(() => {
        if (props.roleMask)
        {
            setIsRoleAuthorized((roleMask & props.roleMask) > 0 && getToken() != null);
        }
        else 
            setIsRoleAuthorized(true);
        if (props.labFilter && props.labFilter.length > 0) {
            if (!rootModel ||( props.labFilter!.indexOf((rootModel.CurrentUserProfile.LabId ?? -1)) < 0))
                setIsLabAuthorized(false);
            else
                setIsLabAuthorized(true);
        }
        if (props.divisionFilter && props.divisionFilter.length > 0) {
            if (!rootModel ||( props.divisionFilter!.indexOf((rootModel.CurrentUserProfile.DivisionId ?? -1)) < 0))
                setIsDivisionAuthorized(false);
            else
                setIsDivisionAuthorized(true);
        }
    }, [roleMask, rootModel]);
    return (
        <>
            {(isRoleAuthorized && isLabAuthorized && isDivisionAuthorized) ? props.children : props.notAuthorized}
        </>
    )
}

export interface authorizedProps {
    children: ReactElement;
    notAuthorized?: ReactElement;
    roleMask? : EnumMemberGroupAliases;
    labFilter? : number[]
    divisionFilter? : number[]
}